import React, { FC, ReactElement } from 'react';
import { Field } from 'formik';
import { camelize } from 'inflection';

import {
  WizardSubmitButton,
  WizardPage,
  WizardPreviousButton
} from 'buyside/components/presentation/Form/Wizard/Wizard';
import RadioField from 'buyside/components/presentation/Form/Field/RadioField/radioField';
import PageHeader from 'buyside/components/presentation/AccreditedInvestorProfilePage/Helpers/pageHeader';
import { generateRadios } from 'buyside/components/presentation/AccreditedInvestorProfilePage/Helpers/util';
import { financialBackgroundSchema } from 'buyside/components/presentation/AccreditedInvestorProfilePage/Helpers/validations';

const { accreditationQuestionnaire } = require('buyside/util/constantsFromRails.json');

import styles from 'buyside/components/presentation/AccreditedInvestorProfilePage/Pages/pageStyles.scss';

const FinancialBackground: FC<{
  isLoading: boolean;
  validationSchema: typeof financialBackgroundSchema;
}> = ({ isLoading, validationSchema }): ReactElement => {
  return (
    <WizardPage validationSchema={validationSchema}>
      <PageHeader subHeader="Financial Background" />
      {accreditationQuestionnaire.map((questionObject: { question: string; names: string[] }) => (
        <div className={styles.field} key={questionObject.question}>
          {questionObject.names.length === 1 && (
            <Field
              className={styles.fieldSelects}
              component={RadioField}
              label={questionObject.question}
              name={camelize(questionObject.names[0], true)}
              options={generateRadios(questionObject.names[0])}
              inColumn
            />
          )}
        </div>
      ))}
      <div className={styles.actionsContainer}>
        <WizardPreviousButton previousText="Back" />
        <WizardSubmitButton submitText="Continue" isLoading={isLoading} />
      </div>
    </WizardPage>
  );
};

export default FinancialBackground;
